import { useMemo, useState } from 'react';
import { useQuery } from 'urql';
import PageHeader from '@/components/Layout/PageHeader.jsx';
import { SECURITY_AUDIT_QUERY } from '@/pages/Seguridad/Usuarios/gql.js';

const pretty = (value) => {
  if (value == null) return '-';
  return JSON.stringify(value, null, 2);
};

export default function AuditoriaList() {
  const [filters, setFilters] = useState({ entidad: '', entidadId: '' });
  const [selected, setSelected] = useState(null);
  const [{ data, fetching, error }] = useQuery({
    query: SECURITY_AUDIT_QUERY,
    variables: {
      entityType: filters.entidad || null,
      entityId: filters.entidadId || null,
    },
  });

  const logs = data?.security_audit || [];

  const diff = useMemo(() => {
    if (!selected?.diff) return [];
    return Object.entries(selected.diff).map(([field, value]) => ({
      field,
      before: value?.before ?? null,
      after: value?.after ?? null,
    }));
  }, [selected]);

  return (
    <div className="min-h-screen w-full bg-[rgb(var(--bg))] pb-16">
      <div className="mx-auto flex w-full max-w-[1400px] flex-col gap-6 px-6 pt-10">
        <PageHeader title="Auditoría de seguridad" subtitle="Historial de altas, cambios de permisos, bloqueos y reasignaciones." />

        <section className="card p-4">
          <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
            <input className="input" placeholder="Tipo de entidad (USER, ROLE, PERMISSION)" value={filters.entidad} onChange={(event) => setFilters((current) => ({ ...current, entidad: event.target.value }))} />
            <input className="input" placeholder="ID de entidad" value={filters.entidadId} onChange={(event) => setFilters((current) => ({ ...current, entidadId: event.target.value }))} />
          </div>
        </section>

        <section className="card overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-[rgba(var(--border),0.35)]">
              <thead>
                <tr>
                  <th className="px-4 py-2 text-left">Fecha</th>
                  <th className="px-4 py-2 text-left">Entidad</th>
                  <th className="px-4 py-2 text-left">ID</th>
                  <th className="px-4 py-2 text-left">Acción</th>
                  <th className="px-4 py-2 text-left">Actor</th>
                </tr>
              </thead>
              <tbody>
                {fetching ? <tr><td colSpan={5} className="px-4 py-3">Cargando...</td></tr> : null}
                {!fetching && error ? <tr><td colSpan={5} className="px-4 py-3 text-red-500">{error.message}</td></tr> : null}
                {!fetching && !error && logs.map((log) => (
                  <tr key={log.id} className="cursor-pointer hover:bg-[rgba(var(--brand),0.05)]" onClick={() => setSelected(log)}>
                    <td className="px-4 py-2">{new Date(log.createdAt).toLocaleString()}</td>
                    <td className="px-4 py-2">{log.entityType}</td>
                    <td className="px-4 py-2">{log.entityId}</td>
                    <td className="px-4 py-2">{log.action}</td>
                    <td className="px-4 py-2">{log.actorUserId || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        <section className="card p-4">
          <h3 className="mb-2 text-sm font-semibold">Diff</h3>
          {!selected ? <p className="text-sm">Seleccioná un registro.</p> : (
            <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
              <pre className="rounded bg-black/5 p-3 text-xs">{pretty(selected.diff)}</pre>
              <pre className="rounded bg-black/5 p-3 text-xs">{pretty(selected.diff)}</pre>
              <div className="lg:col-span-2">
                <table className="min-w-full text-xs">
                  <thead><tr><th className="px-2 py-1 text-left">Campo</th><th className="px-2 py-1 text-left">Antes</th><th className="px-2 py-1 text-left">Después</th></tr></thead>
                  <tbody>
                    {diff.map((row) => (
                      <tr key={row.field}>
                        <td className="px-2 py-1">{row.field}</td>
                        <td className="px-2 py-1">{pretty(row.before)}</td>
                        <td className="px-2 py-1">{pretty(row.after)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </section>
      </div>
    </div>
  );
}
